import React, {useEffect} from "react";
import {BrowserRouter as Router, useLocation, useNavigate} from "react-router-dom";
import AppLayout from "./containers/AppLayout";
import auth from "./api/auth";

const publicRoutes = [
    "/",
    "/privacy",
    "/faq",
    "/terms-of-use",
    "/what-is-the-perill-model",
    "/pricing-plans",
    "/get-in-touch",
    "/team-coaching",
    "/about-ccmi",
    "/perill-how-it-works",
    "/perill-resources",
    "/line-managers-and-hr-professionals",
    "/team-coaches",
    "/enterprise",
    "/login",
    "/forgot-password",
    "/reset-password",
    "/password-changed",
    "/logout",
    "/logged_out",
    "/register",
    "/error",
    "/forbidden",
    "/questionnaire",
    "/verify",
    "/settings-flow-handler",
]

const isPublicRoute = (path) => {
    return publicRoutes.some((route) => {
        if (route === "/") {
            return path === "/"
        }
        return path === route || path.startsWith(`${route}/`)
    })
}

function AppContent() {
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (localStorage.getItem("change_password") === "true") {
            return
        }

        auth.hasSession().then((session) => {
            if (session === "mfa") {
                return
            }
            if (!session && !isPublicRoute(location.pathname)) {
                navigate("/login")
            }
        })

    }, [location.pathname]);

    useEffect( () => {
        let changing_password = localStorage.getItem("change_password")
        if (changing_password === "true") {
            localStorage.removeItem("change_password")
            navigate("/logout?return_to=password-changed")
        }
        localStorage.removeItem("change_password")
    }, [location.pathname]);

    return (
        <AppLayout />
    );
}

function App() {
  return (
      <Router>
        <AppContent />
      </Router>
  );

}

export default App;